import { Component, HostBinding, Input } from '@angular/core'

@Component({
	selector: 'more-vert-icon',
	template: `
		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="icon icon-tabler icon-tabler-dots-vertical"
			[attr.width]="size"
			viewBox="0 0 24 24"
			[attr.stroke-width]="stroke"
			stroke="currentColor"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
			<path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
			<path d="M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
			<path d="M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
		</svg>
	`,
	styles: [
		`
			:host {
				display: inline-block;
			}
		`,
	],
	standalone: true,
})
export class MoreVertIconComponent {
	@Input() size: number = 18
	@Input() stroke: 1 | 1.25 | 1.5 | 1.75 | 2 = 2

	@HostBinding('style.height') get height() {
		return `${this.size}px`
	}
	@HostBinding('style.width') get width() {
		return `${this.size}px`
	}
}
